module.exports = __webpack_public_path__ + "img/alelo-icon.c6e903e5.png";